import { render, staticRenderFns } from "./TextAndImg.vue?vue&type=template&id=2800161b&scoped=true&"
import script from "./TextAndImg.vue?vue&type=script&lang=js&"
export * from "./TextAndImg.vue?vue&type=script&lang=js&"
import style0 from "./TextAndImg.vue?vue&type=style&index=0&id=2800161b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800161b",
  null
  
)

export default component.exports